<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Popup Banner</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Popup Banner</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PopupBanner">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'PopupBannerList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Title</label>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      v-bind:class="{ 'has-error': errors.has('title') }"
                      v-validate="'required'"
                      v-model="value.title"
                      class="form-control title"
                      placeholder="Title"
                    />
                    <div class="help text-danger" v-show="errors.has('title')">
                      {{ errors.first("title") }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>Banner Image</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="banner_image"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input
                              type="file"
                              v-bind:class="{
                                'has-error': errors.has('banner_image'),
                              }"
                              name="banner_image"
                              class="custom-file-input"
                              id="banner_image"
                              @change="select_file_banner_image"
                            />
                            <label
                              class="custom-file-label"
                              for="banner_image"
                            ></label>
                            <label class="custom-file-label" for="banner_image"
                              >Choose file</label
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="help text-danger"
                        v-show="errors.has('banner_image')"
                      >
                        {{ errors.first("banner_image") }}
                      </div>
                      <div class="form-group" v-if="value.banner_image_name">
                        {{ value.banner_image_name }}
                        &nbsp;
                        <i
                          class="fas fa-window-close"
                          @click="removeFile()"
                        ></i>
                      </div>
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Start Date</label>
                    <div class="clearfix"></div>
                    <date-picker
                      type="datetime"
                      input-class="form-control"
                      v-model="value.start_date"
                      v-validate="'required'"
                      lang="en"
                      format="YYYY-MM-DD hh:mm:ss"
                      value-type="YYYY-MM-DD hh:mm:ss"
                    ></date-picker>
                    <div
                      class="help text-danger"
                      v-show="errors.has('start_date')"
                    >
                      {{ errors.first("start_date") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Expire At</label>
                    <div class="clearfix"></div>
                    <date-picker
                      type="datetime"
                      input-class="form-control"
                      v-model="value.expire_date"
                      v-validate="'required'"
                      lang="en"
                      format="YYYY-MM-DD hh:mm:ss"
                      value-type="YYYY-MM-DD hh:mm:ss"
                    ></date-picker>
                    <div
                      class="help text-danger"
                      v-show="errors.has('expire_date')"
                    >
                      {{ errors.first("expire_date") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        v-bind:class="{
                          'has-error': errors.has('is_active'),
                        }"
                        type="checkbox"
                        :id="'is_active'"
                        name="is_active"
                        v-model="value.is_active"
                      />
                      <label :for="'is_active'" class="custom-control-label"
                        >Is Active ?</label
                      >
                    </div>
                    <div
                      class="help text-danger"
                      v-show="errors.has('is_active')"
                    >
                      {{ errors.first("is_active") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { DepartmentsAPI, CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "PopupBannerForm",
  metaInfo: {
    title: "Popup Banner | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      banner_image: "",
      banner_image_name: "Choose file",
    },
    pre: {},
  }),
  methods: {
    select_file_banner_image: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.value.banner_image = reader.result;
          this.$set(
            this.value,
            "banner_image_name",
            event.target.files[0].name
          );
        };
      } catch (e) {
        //console.log(e);
      }
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/popup_banners";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/popup_banners/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "PopupBannerList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/popup_banners/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            var filename = this.value.banner_image
              ? this.value.banner_image.split("images/")
              : [];
            this.value.banner_image_name =
              filename.length > 0 ? filename[1] : "";
          })
          .catch((error) => {
            console.log(error.response);
          });

        // this.value.banner_image = "";
      }

      this.is_loading = false;
    },
    removeFile: function () {
      this.value.banner_image_name = null;
      this.value.banner_image = null;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
